(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[138],{

/***/ "3cys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/widgets/product-introduction-actions/ProductIntroductionActions.jsx
var ProductIntroductionActions = __webpack_require__("6Jj1");

// EXTERNAL MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx + 1 modules
var ProductLogo = __webpack_require__("hA0C");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/widgets/product-introduction/ProductIntroduction.jsx
var __jsx = react_default.a.createElement;













var ProductIntroduction_ProductIntroduction = function ProductIntroduction(_ref) {
  var className = _ref.className,
      iconName = _ref.iconName,
      isExclusiveCollection = _ref.isExclusiveCollection,
      imageSrc = _ref.imageSrc,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      ratingImage = _ref.ratingImage,
      reduceLabel = _ref.reduceLabel,
      seasonLink = _ref.seasonLink,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      title = _ref.title;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var track = Object(useTracking["a" /* useTracking */])();

  if (!title) {
    return null;
  }

  var seeMoreSize = isDesktop ? 120 : 90;

  var top = __jsx("div", {
    className: "relative inset-x-0 -top-[6.25rem] z-1 mx-auto -mb-100 w-160 rounded-12 bg-white p-15 pt-20 shadow-subtle lg:absolute lg:-top-[3.75rem] lg:mb-0 lg:w-180"
  }, __jsx(ProductLogo["a" /* ProductLogo */], {
    className: "mb-30",
    iconName: iconName,
    isExclusiveCollection: isExclusiveCollection,
    productCountry: productCountry,
    productName: productName
  }), __jsx(ProductIntroductionActions["a" /* ProductIntroductionActions */], {
    ratingImage: ratingImage
  }));

  var seasonSwitch = seasonLink && seasonLink.url && __jsx(DynamicLink["a" /* default */], {
    className: "inline-flex items-center justify-center gap-10 rounded-pill p-15 text-14 font-bold leading-1 text-black shadow-subtle transition-colors duration-250 ease-in hocus:text-black-active lg:text-16",
    onClick: function onClick() {
      return track({
        actionGA: 'blockInfos',
        labelGA: 'switchSeason'
      });
    },
    url: seasonLink.url
  }, __jsx(Icon["a" /* Icon */], {
    name: seasonLink.iconName,
    width: isDesktop ? '1.375rem' : '1rem'
  }), seasonLink.label);

  var content = __jsx(react["Fragment"], null, __jsx(Title["a" /* Title */], {
    className: "mb-20 font-brand text-28 font-bold leading-tight md:text-44",
    theme: "none"
  }, Object(string_util["d" /* truncate */])(title, 50)), __jsx(TextSeeMore["a" /* TextSeeMore */], {
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: !isDesktop,
    seeLessLabel: reduceLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize,
    text: text,
    theme: "text-sans-n3"
  }));

  return isDesktop ? __jsx("article", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate mt-60 pt-20', className)
  }, top, __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: "relative z-0 w-1/2 overflow-hidden rounded-12"
  }, __jsx(Image["b" /* default */], {
    imageUrl: imageSrc,
    ratioKey: ratios_utils["c" /* default */].R_63_BY_58,
    ratioDisplay: 1 / 2
  })), __jsx("div", {
    className: "relative flex w-1/2 items-center py-60"
  }, __jsx("div", {
    className: "absolute end-0 top-0"
  }, seasonSwitch), __jsx("div", {
    className: "ms-auto w-5/6 ps-20"
  }, content)))) : __jsx("article", {
    className: className
  }, __jsx("div", {
    className: "mb-40 pt-20"
  }, __jsx("div", {
    className: "mx-auto max-w-400 overflow-hidden rounded-12"
  }, __jsx(Image["b" /* default */], {
    imageUrl: imageSrc,
    ratioKey: ratios_utils["c" /* default */].SQUARE
  })), top, __jsx("div", {
    className: "flex justify-center pt-15"
  }, seasonSwitch)), content);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/InfoBannerContainer.jsx
var InfoBannerContainer = __webpack_require__("wgpp");

// CONCATENATED MODULE: ./src/client/components/lines/product-introduction-line/ProductIntroductionLine.jsx



var ProductIntroductionLine_jsx = react_default.a.createElement;







var ProductIntroductionLine_ProductIntroductionLine = function ProductIntroductionLine(_ref) {
  var config = _ref.config,
      hasSeasonButton = _ref.hasSeasonButton,
      hasTripadvisorButton = _ref.hasTripadvisorButton,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      resort = _ref.resort;
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);

  if (!config || !resort) {
    return null;
  }

  var descriptionTitle = resort.descriptionTitle,
      description = resort.description,
      country = resort.destination.country,
      icon = resort.icon,
      productId = resort.id,
      _resort$images = resort.images,
      images = _resort$images === void 0 ? [] : _resort$images,
      isDoubleSeason = resort.isDoubleSeason,
      isExclusiveCollection = resort.isExclusiveCollection,
      isWinter = resort.isWinter,
      linkedResort = resort.linkedResort,
      name = resort.name,
      _resort$tripadvisor = resort.tripadvisor,
      _resort$tripadvisor$r = _resort$tripadvisor.rating,
      rating = _resort$tripadvisor$r === void 0 ? '' : _resort$tripadvisor$r,
      _resort$tripadvisor$r2 = _resort$tripadvisor.ratingImageUrl,
      ratingImageUrl = _resort$tripadvisor$r2 === void 0 ? '' : _resort$tripadvisor$r2;
  var _config$common = config.common,
      loadLess = _config$common.loadLess,
      viewMore = _config$common.viewMore,
      _config$resort$resort = config.resort.resortIntroduction,
      toSummerLabel = _config$resort$resort.toSummerLabel,
      toWinterLabel = _config$resort$resort.toWinterLabel;
  var productIntroductionProps = {
    iconName: icon,
    imageSrc: imageSrc || images[2] || images[1] || images[0],
    productCountry: country,
    productName: name,
    ratingImage: hasTripadvisorButton ? {
      alt: "Tripadvisor: ".concat(rating),
      src: ratingImageUrl
    } : null,
    reduceLabel: loadLess,
    seasonLink: isDoubleSeason || !hasSeasonButton ? null : {
      iconName: isWinter ? icons["a" /* ICONS */].SUN : icons["a" /* ICONS */].MOUNTAIN,
      label: isWinter ? toSummerLabel : toWinterLabel,
      url: linkedResort && linkedResort.href
    },
    seeMoreLabel: viewMore,
    title: descriptionTitle,
    text: description,
    isExclusiveCollection: isExclusiveCollection
  };
  return ProductIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line pt-1",
    "data-testid": "resort-introduction",
    id: id,
    size: "large"
  }, ProductIntroductionLine_jsx(InfoBannerContainer["a" /* InfoBannerContainer */], {
    className: "z-1 pb-20 pt-40 lg:pb-40 lg:pt-20",
    contentClassName: "justify-center",
    departureDate: departureDate,
    duration: duration,
    popinPosition: "center",
    productId: productId
  }), ProductIntroductionLine_jsx(ProductIntroduction_ProductIntroduction, productIntroductionProps));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-introduction/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductIntroductionLine_ProductIntroductionLine);

/***/ }),

/***/ "3jv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Heading_Heading; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__("VqYj");
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);

// EXTERNAL MODULE: /opt/webapp/node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__("l24s");
var remark_breaks_default = /*#__PURE__*/__webpack_require__.n(remark_breaks);

// EXTERNAL MODULE: ./src/client/components/utils/markdown/markdown.js
var markdown = __webpack_require__("ZMpj");

// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.themes.js
var themes = {
  none: {
    thRoot: ''
  },
  'heading-brand-1': {
    thRoot: 'text-black font-brand text-32 leading-tight'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var MARKDOWN_ALLOWED_TYPES = [markdown["a" /* HTML_ELEMENTS */].BREAK.type, markdown["a" /* HTML_ELEMENTS */].EMPHASIS.type, markdown["a" /* HTML_ELEMENTS */].PARAGRAPH.type, markdown["a" /* HTML_ELEMENTS */].STRONG.type, markdown["a" /* HTML_ELEMENTS */].TEXT.type];

var HeadingText = function HeadingText(_ref) {
  var children = _ref.children;
  return children;
};

var Heading_Heading = function Heading(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$hLevel = _ref2.hLevel,
      hLevel = _ref2$hLevel === void 0 ? 1 : _ref2$hLevel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'heading-brand-1' : _ref2$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["children", "className", "hLevel", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var thRoot = themes[theme].thRoot;
  return __jsx(react_markdown_default.a, {
    allowedTypes: MARKDOWN_ALLOWED_TYPES,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    plugins: [remark_breaks_default.a],
    renderers: {
      root: Object(markdown["c" /* markdownRootHeadingRenderer */])(_objectSpread(_objectSpread({}, rest), {}, {
        hLevel: hLevel
      })),
      paragraph: HeadingText
    }
  }, children);
};

/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "M/0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInfoBannerQuery; });
var getInfoBannerQuery = function getInfoBannerQuery(productId) {
  return "query {\n    productInformationBanners(productId:\"".concat(productId, "\") {\n        productId\n        salesChannel {\n          context\n          tags\n        }\n        countdown {\n          dateTimeEnd\n          daysLabel\n          hoursLabel\n          minutesLabel\n          secondsLabel\n        }\n        popin {\n          title\n          subtitle\n          text: description\n          buttonLabel\n          url\n          image\n          color\n        }\n        startDate\n        endDate\n        toaster {\n          title\n          subtitle: description\n          iconName\n          illustration: picto\n          color\n        }\n    }\n  }");
};

/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getArrivalDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var arrivalDate = _ref5.arrivalDate;
  return arrivalDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinEmail = _ref6.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinSms = _ref7.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinMail = _ref8.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinPhone = _ref9.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref10) {
  var optinFosun = _ref10.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var duration = _ref11.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref12) {
  var flexibility = _ref12.flexibility;
  return flexibility;
});


/***/ }),

/***/ "UpHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ infoBanner_utils_renderInfoBanner; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/capitalize.js
var capitalize = __webpack_require__("h++M");
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/heading/Heading.jsx + 1 modules
var Heading = __webpack_require__("3jv5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/InfoBanner.themes.js
var InfoBanner_themes = __webpack_require__("cN29");

// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/InfoBanner.jsx




var __jsx = react_default.a.createElement;














var positions = {
  left: 'start-0',
  right: 'end-0',
  center: 'inset-x-0'
};
var InfoBanner_InfoBanner = function InfoBanner(_ref) {
  var className = _ref.className,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? 'w-800' : _ref$containerClassNa,
      contentClassName = _ref.contentClassName,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
      countdown = _ref.countdown,
      iconName = _ref.iconName,
      illustration = _ref.illustration,
      popin = _ref.popin,
      _ref$popinPosition = _ref.popinPosition,
      popinPosition = _ref$popinPosition === void 0 ? 'left' : _ref$popinPosition,
      subtitle = _ref.subtitle,
      title = _ref.title,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var hasModal = !!popin && (!!(popin === null || popin === void 0 ? void 0 : popin.title) || !!(popin === null || popin === void 0 ? void 0 : popin.text) || !!(popin === null || popin === void 0 ? void 0 : popin.subtitle));
  var hasCountdown = !isEmpty_default()(countdown) && countdown.dateTimeEnd;
  var hasIcon = Boolean(illustration || iconName);
  var _themes$theme = Object(InfoBanner_themes["a" /* themes */])({
    color: color
  })[theme],
      thDescriptionBloc = _themes$theme.thDescriptionBloc,
      thPopinContent = _themes$theme.thPopinContent,
      thPopinContentImage = _themes$theme.thPopinContentImage,
      thPopinColor = _themes$theme.thPopinColor,
      thPopinTextColor = _themes$theme.thPopinTextColor;

  if (!title && !subtitle && !hasIcon && !hasCountdown) {
    return null;
  }

  var content = __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('text-initial flex', contentClassName)
  }, hasIcon && __jsx("div", {
    className: "border-".concat(color, " h-56 shrink-0 overflow-hidden rounded-4 border-1")
  }, illustration ? __jsx("img", {
    alt: "",
    className: "h-full",
    src: illustration
  }) : __jsx(Icon["a" /* Icon */], {
    className: "text-".concat(color, " p-5"),
    name: iconName,
    width: "3.5rem"
  })), hasCountdown && __jsx("div", {
    className: "bg-white border-".concat(color, " flex h-56 grow flex-col items-center justify-center overflow-hidden rounded-4 border-1 sm:order-1 sm:grow-0 text-").concat(color)
  }, __jsx(Countdown["a" /* Countdown */], Object(esm_extends["a" /* default */])({}, countdown, {
    dateTimeEnd: countdown === null || countdown === void 0 ? void 0 : countdown.dateTimeEnd,
    theme: "infoBanner"
  }))), (title || subtitle) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thDescriptionBloc, 'h-56')
  }, __jsx("h6", {
    className: "text-10"
  }, subtitle), __jsx("h5", {
    className: "font-brand text-16 font-normal underline"
  }, title)));

  var imageProps = isDesktop ? {
    dimensions: {
      w: 300,
      h: 170
    }
  } : {
    dontChangeAnything: true
  };
  var tooltipContent = hasModal ? __jsx("div", {
    className: thPopinContent
  }, (popin === null || popin === void 0 ? void 0 : popin.image) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thPopinContentImage, 'lg:h-220')
  }, __jsx(Image["a" /* Image */], Object(esm_extends["a" /* default */])({
    className: "h-full overflow-hidden rounded-12",
    imageUrl: popin.image
  }, imageProps))), __jsx("div", {
    className: "p-20"
  }, (popin === null || popin === void 0 ? void 0 : popin.title) && __jsx(Heading["a" /* Heading */], {
    className: Object(classnames_utils["a" /* classnames */])('font-brand text-24 font-normal leading-tight', "text-".concat(thPopinColor)),
    hLevel: 3,
    theme: "none"
  }, popin.title), (popin === null || popin === void 0 ? void 0 : popin.subtitle) && __jsx(Heading["a" /* Heading */], {
    className: "text-14 font-bold leading-tight",
    hLevel: 4,
    theme: "none"
  }, popin.subtitle), (popin === null || popin === void 0 ? void 0 : popin.text) && __jsx(Text["a" /* Text */], {
    className: "py-10 text-14 leading-tight lg:leading-loose",
    text: popin.text
  }), (popin === null || popin === void 0 ? void 0 : popin.url) && __jsx(Button["a" /* Button */], {
    color: thPopinTextColor,
    colorBg: thPopinColor,
    url: popin.url
  }, popin.buttonLabel))) : null;
  var position = popinPosition === 'left' ? 'left' : 'right';
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', className)
  }, hasModal ? __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: (popin === null || popin === void 0 ? void 0 : popin.title) ? popin.title : '',
    className: "flex justify-end",
    containerClassName: Object(classnames_utils["a" /* classnames */])("z-3 border-1 border-".concat(color, " ").concat(positions[popinPosition]), containerClassName),
    contentClassName: "arrow-bg arrow-bg-".concat(color, " arrow-up").concat(capitalize_default()(position)),
    content: tooltipContent,
    hasCloseButton: true,
    onClick: function onClick() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_INFOBANNER, {
        detail_click: title
      });
    },
    theme: "infoBanner"
  }, content) : content);
};
// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/infoBanner.utils.js













var infoBanner_utils_jsx = react["createElement"];

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






 // eslint-disable-next-line clubmed/no-fake-component

var infoBanner_utils_renderInfoBanner = function renderInfoBanner(_ref) {
  var infoBannerData = _ref.infoBannerData,
      departureDate = _ref.departureDate,
      arrivalDate = _ref.arrivalDate,
      currentStep = _ref.currentStep,
      containerClassName = _ref.containerClassName,
      theme = _ref.theme,
      contentClassName = _ref.contentClassName,
      popinPosition = _ref.popinPosition,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'mb-20 z-2' : _ref$className;
  var content = ((infoBannerData === null || infoBannerData === void 0 ? void 0 : infoBannerData.productInformationBanners) || []).map(function (productInformationBanner, index) {
    var theContextInfoBannerData = productInformationBanner.salesChannel.find(function (el) {
      return el.context === 'B2C';
    });
    var isDepartureDateIncludedInBannerDates = moment_default()(departureDate).isBetween(Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.startDate), Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate), null, []) || moment_default()(arrivalDate).isBetween(Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.startDate), Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate), null, []) || Object(apiDate["j" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate).isSame(arrivalDate);

    if (!theContextInfoBannerData || !isDepartureDateIncludedInBannerDates || !theContextInfoBannerData.tags.includes(currentStep)) {
      return null;
    }

    var countdown = productInformationBanner.countdown,
        popin = productInformationBanner.popin,
        toaster = productInformationBanner.toaster;
    var infoBannerCountdown = countdown ? _objectSpread(_objectSpread({}, countdown), {}, {
      dateTimeEnd: moment_default()(countdown.dateTimeEnd, 'YYYYMMDD HH:mm:ss'),
      days: Object(i18n["h" /* t */])('options.countdownLabels.days'),
      hours: Object(i18n["h" /* t */])('options.countdownLabels.hours'),
      minutes: Object(i18n["h" /* t */])('options.countdownLabels.minutes'),
      seconds: Object(i18n["h" /* t */])('options.countdownLabels.seconds')
    }) : null;
    return infoBanner_utils_jsx(InfoBanner_InfoBanner, Object(esm_extends["a" /* default */])({
      key: "infoBanner_".concat(index)
    }, toaster, {
      containerClassName: containerClassName,
      contentClassName: contentClassName,
      countdown: infoBannerCountdown,
      popin: popin,
      popinPosition: popinPosition,
      theme: theme
    }));
  }).filter(Boolean);

  if (!content.length) {
    return null;
  }

  return infoBanner_utils_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate flex flex-col gap-10 sm:flex-row', className)
  }, content);
};

/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'TextSeeMore' : _ref$dataTestIdPrefix,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeMoreColor = _ref.seeMoreColor,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "dataTestIdPrefix", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeMoreColor", "seeLessLabel", "seeMoreLabel", "seeMoreSize"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
    className: className,
    color: seeMoreColor,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, textProps, {
    "data-testid": "".concat(dataTestIdPrefix, "-text")
  })));
};

/***/ }),

/***/ "Xzib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopOver_PopOver; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-large arrow-white bg-white after:drop-shadow-md mb-20 rounded-2 shadow-md',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  infoBanner: {
    thTrigger: 'w-full',
    thContainer: 'absolute top-full animate-fadeIn animation-duration-500 mt-5 rounded-2',
    thContent: ' arrow-white bg-white',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.875rem'
  },
  priceOfStayTooltip: {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md mb-20 rounded-2',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  fancy: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-bg arrow-bg-black arrow-downLeft arrow-large arrow-white bg-white border-1 border-black after:drop-shadow-md mb-20 rounded-12 shadow-md',
    thCloseButton: 'absolute leading-0 p-10 end-0 top-0 text-grey',
    thCloseIconWidth: '0.625rem'
  },
  favorite: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-end',
    thContent: 'arrow-downRight arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  'favorite-centered': {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-center',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  typesOfStaySearchFilter: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 -mb-5 w-screen',
    thContent: 'flex w-full leading-1',
    thCloseButton: '',
    thTrigger: 'leading-0',
    thCloseIconWidth: ''
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx

var __jsx = react_default.a.createElement;









var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      content = _ref.content,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _ref$isInitiallyVisib = _ref.isInitiallyVisible,
      isInitiallyVisible = _ref$isInitiallyVisib === void 0 ? false : _ref$isInitiallyVisib,
      _ref$isModalOnly = _ref.isModalOnly,
      isModalOnly = _ref$isModalOnly === void 0 ? false : _ref$isModalOnly,
      _onClick = _ref.onClick,
      onRender = _ref.onRender,
      onTimeout = _ref.onTimeout,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      timeoutInMs = _ref.timeoutInMs,
      triggerOnHover = _ref.triggerOnHover;

  var _useState = Object(react["useState"])(isInitiallyVisible),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(react["useEffect"])(function () {
    onRender && onRender();

    if (timeoutInMs && timeoutInMs > 0) {
      setTimeout(function () {
        setIsVisible(false);
        onTimeout && onTimeout();
      }, timeoutInMs);
    }

    return function () {
      onTimeout && onTimeout();
    };
  }, []);
  var shouldTriggerOnHover = triggerOnHover && isDesktop;
  Object(react["useEffect"])(function () {
    var timeoutId;

    if (shouldTriggerOnHover && isVisible && _onClick) {
      timeoutId = setTimeout(_onClick, 300);
      return function () {
        clearTimeout(timeoutId);
      };
    }
  }, [isVisible, shouldTriggerOnHover]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTrigger = _themes$theme.thTrigger,
      thContainer = _themes$theme.thContainer,
      thContent = _themes$theme.thContent,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseIconWidth = _themes$theme.thCloseIconWidth;
  return __jsx("div", Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', className)
  }, shouldTriggerOnHover && {
    onMouseEnter: function onMouseEnter(e) {
      setIsVisible(true);

      if (!shouldTriggerOnHover) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      }
    },
    onMouseLeave: function onMouseLeave() {
      setIsVisible(false);
    }
  }), __jsx("button", {
    className: thTrigger,
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();

      if (!timeoutInMs) {
        setIsVisible(!isVisible);
      }

      if (!isVisible && !shouldTriggerOnHover && _onClick) {
        _onClick(e);
      }
    },
    type: "button"
  }, children), isVisible && (isDesktop && !isModalOnly ? __jsx(ClickOutside["a" /* ClickOutside */], {
    className: Object(classnames_utils["a" /* classnames */])(thContainer, containerClassName),
    onClick: function onClick() {
      setIsVisible(false);
    }
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thContent, contentClassName)
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    onClick: function onClick() {
      return setIsVisible(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), content)) : __jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};

/***/ }),

/***/ "cN29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");




var themes = function themes(_ref) {
  var color = _ref.color;
  var rColor = _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS_LIST */ "b"].includes(color) ? color : _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].TURQUOISE;
  var thDescriptionBloc = "bg-".concat(rColor, " px-5 flex flex-col grow sm:grow-0 justify-center pe-10 rounded-4 text-").concat(_utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor], " w-auto");
  var thPopinContent = "border-1 border-".concat(rColor, " lg:border-0 flex flex-col");
  return {
    "default": {
      thDescriptionBloc: thDescriptionBloc,
      thPopinContent: "".concat(thPopinContent, " lg:flex-row"),
      thPopinContentImage: 'shrink-0 px-20 pt-20 lg:ps-20 lg:pe-0 lg:py-15',
      thPopinColor: rColor,
      thPopinTextColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor]
    },
    comparator: {
      thDescriptionBloc: "".concat(thDescriptionBloc, " sm:w-full"),
      thPopinContent: thPopinContent,
      thPopinContentImage: 'shrink-0 lg:ps-10 lg:py-10 mt-15',
      thPopinColor: rColor,
      thPopinTextColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor]
    }
  };
};

/***/ }),

/***/ "hA0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductLogo_ProductLogo; });

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.theme.js

var themes = {
  "default": function _default(_ref) {
    var isExclusiveCollection = _ref.isExclusiveCollection;
    return {
      thRoot: 'text-center',
      thIcon: Object(classnames_utils["a" /* classnames */])('mb-15', {
        'rounded-full bg-lightSand p-15 text-black': !isExclusiveCollection
      }, {
        'rounded-12 border-5 border-ultramarine p-10 text-ultramarine': isExclusiveCollection
      }),
      thIconWidth: '6.25rem',
      thIsNotSquare: false,
      thProductInfo: 'flex flex-col-reverse text-initial',
      thProductCountry: 'font-bold text-14 text-sienna truncate w-full',
      thProductName: 'font-bold leading-tight text-18'
    };
  },
  calendar: function calendar() {
    return {
      thRoot: 'font-brand leading-tight text-black text-center text-16',
      thIconWidth: '5rem',
      thIsNotSquare: true
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx
var __jsx = react_default.a.createElement;




var ProductLogo_ProductLogo = function ProductLogo(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      iconName = _ref.iconName,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isExclusiveCollection: isExclusiveCollection
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thIsNotSquare = _themes$theme.thIsNotSquare,
      thProductInfo = _themes$theme.thProductInfo,
      thProductName = _themes$theme.thProductName,
      thProductCountry = _themes$theme.thProductCountry;

  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, __jsx(Icon["a" /* Icon */], {
    alt: productName,
    className: thIcon,
    isNotSquare: thIsNotSquare,
    name: iconName,
    width: thIconWidth
  }), __jsx("div", {
    className: thProductInfo
  }, productName && __jsx("p", {
    className: thProductName,
    "data-testid": "product-logo-name"
  }, productName), productCountry && __jsx("p", {
    className: thProductCountry,
    "data-testid": "product-logo-country"
  }, productCountry)));
};

/***/ }),

/***/ "wgpp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoBannerContainer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _infoBanner_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UpHs");
/* harmony import */ var _infoBanner_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("M/0w");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("EkOT");
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("829J");
/* harmony import */ var _InfoBanner_themes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("cN29");


var _pageMappings;











var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["b2cPagesService"].PAGE_TYPES;
var pageMappings = (_pageMappings = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_pageMappings, PAGE_TYPES.RESORT, 'resort_page'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_pageMappings, PAGE_TYPES.PLE, 'customer_area'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_pageMappings, _tracking_constants__WEBPACK_IMPORTED_MODULE_9__[/* STATIC_PAGE_TYPES */ "C"].SHOPPING_SEARCH, 'comparator'), _pageMappings);
var InfoBannerContainer = function InfoBannerContainer(_ref) {
  var className = _ref.className,
      containerClassName = _ref.containerClassName,
      contentClassName = _ref.contentClassName,
      departureDate = _ref.departureDate,
      duration = _ref.duration,
      popinPosition = _ref.popinPosition,
      productId = _ref.productId,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var appContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_6__[/* usePageContext */ "b"])();

  var _useGQL = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_7__[/* useGQL */ "a"])({
    query: Object(_infoBanner_query__WEBPACK_IMPORTED_MODULE_5__[/* getInfoBannerQuery */ "a"])(productId),
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* WIDGET_PRODUCT_FETCH_INFORMATION_BANNERS */ "pd"]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  var tripEndDate = departureDate && duration && moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).add(duration, 'days').format('YYYY-MM-DD');
  return !isLoading && Object(_infoBanner_utils__WEBPACK_IMPORTED_MODULE_4__[/* renderInfoBanner */ "a"])({
    infoBannerData: data,
    departureDate: departureDate,
    arrivalDate: tripEndDate,
    currentStep: appContext.pageType && pageMappings[appContext.pageType],
    containerClassName: containerClassName,
    theme: theme,
    contentClassName: contentClassName,
    popinPosition: popinPosition,
    className: className
  });
};

/***/ })

}]);